module.exports = require("punycode");;